import api from "./api";
import endpoints from "./endpoints";

export default {
  create: async function (parentId, languageCode, name) {
    const response = await api.post(endpoints.attributeGroups.create, {}, { params: { parentId, languageCode, name } });
    return response.data;
  },
  rename: async function (attributeGroupId, languageCode, uID, name) {
    const response = await api.post(endpoints.attributeGroups.rename, {}, { params: { attributeGroupId, languageCode, uID, name } });
    return response.data;
  },
  delete: async function (attributeGroupId) {
    const response = await api.post(endpoints.attributeGroups.delete, {}, { params: { attributeGroupId } });
    return response.data;
  },
  getPath(language, id) {
    return api
      .get(endpoints.attributePath.get, {
        params: { language, attributeGroupId: id }
      })
      .then((x) => Promise.resolve(x.data));
  },
  search: async function (searchTerm, language) {
    const response = await api.get(endpoints.attributeGroupSearch.get, {
      params: { searchTerm, language }
    });
    return response.data;
  },
  getAttributeGroup(languages, attributeGroupId) {
    return api.get(endpoints.attributeGroups.getAttributeGroup, { params: { languages, attributeGroupId } }).then((x) => Promise.resolve(x.data));
  },
  checkForDuplicates: async function (attributeGroupId, name, languageCode) {
    return await api
      .get(endpoints.attributeGroups.checkForDuplicates, { params: { attributeGroupId, name, languageCode } })
      .then((x) => Promise.resolve(x.data));
  },
  sortAttributeGroups: async function (attributeGroupId, sortDirection, languageCode) {
    const response = await api.post(endpoints.attributeGroups.sort, {}, { params: { attributeGroupId, sortDirection, languageCode } });
    return response.data;
  },
  moveAttributeGroups: async function (action, attributeGroupIds) {
    const response = await api.post(endpoints.attributeGroups.move, attributeGroupIds, { params: { moveActionType: action } });
    return response.data;
  },
  translate: async function (attributeGroupId, sourceLanguage, targetLanguages, translateOnlyEmptyValues, translateSubGroups) {
    const response = await api.post(endpoints.attributeGroups.translate, targetLanguages, {
      params: { attributeGroupId, sourceLanguage, translateOnlyEmptyValues, translateSubGroups }
    });
    return response.data;
  }
};
